import { render, staticRenderFns } from "./HoldingFormDialog.vue?vue&type=template&id=6f6f9636&scoped=true"
import script from "./HoldingFormDialog.vue?vue&type=script&lang=js"
export * from "./HoldingFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6f9636",
  null
  
)

export default component.exports